const STRINGS = {
  expandButtonLabel: (title, expanded) => `${expanded ? "Collapse" : "Expand"} ${title}`,
  collapsedAnnouncement: title => `${title}, collapsed`,
  expandedAnnouncement: title => `${title}, expanded`
};
export default STRINGS;